var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSalesTriggers(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 147,
    height: 169.42,
    viewBox: "0 0 147 169.42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_166",
    x: 0,
    y: 22.42,
    width: 147,
    height: 147,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_192",
    "data-name": "Rectangle 192",
    width: 53.856,
    height: 54.401,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_398",
    "data-name": "Group 398",
    transform: "translate(-1010.5 -2624.08)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_370",
    "data-name": "Group 370",
    transform: "translate(671 66)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_843",
    "data-name": "Path 843",
    d: "M361.162,128.6l2.3-1.836a2.433,2.433,0,0,0-2.816,1.546,3.911,3.911,0,0,0-2.91.18l4.593,1.668a3.476,3.476,0,0,0-1.163-1.557Z",
    transform: "translate(81.31 2448.929)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_844",
    "data-name": "Path 844",
    d: "M735.046,77.5l2.3-1.836a2.433,2.433,0,0,0-2.816,1.546,3.911,3.911,0,0,0-2.91.18l4.593,1.668A3.476,3.476,0,0,0,735.046,77.5Z",
    transform: "translate(-319.479 2492.157)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_367",
    "data-name": "Group 367",
    transform: "translate(-564.132 180.631) rotate(-17)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_8",
    "data-name": "Ellipse 8",
    cx: 11.168,
    cy: 22.788,
    rx: 11.168,
    ry: 22.788,
    transform: "translate(174.65 2546.304)",
    fill: "#5d45ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_853",
    "data-name": "Path 853",
    d: "M549.9,218.79c4.473-26.838.045-53.578,0-53.845l-.87.147c.045.265,4.448,26.866,0,53.553Z",
    transform: "translate(-365.109 2387.603)",
    fill: "#f8e602"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_182",
    "data-name": "Rectangle 182",
    width: 0.883,
    height: 11.453,
    transform: "translate(175.569 2564.97) rotate(-61.858)",
    fill: "#f8e602"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_183",
    "data-name": "Rectangle 183",
    width: 11.454,
    height: 0.883,
    transform: "translate(186.229 2572.303) rotate(-28.158)",
    fill: "#f8e602"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_368",
    "data-name": "Group 368",
    transform: "translate(696.433 34.469) rotate(11)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_8-2",
    "data-name": "Ellipse 8",
    cx: 9.109,
    cy: 18.587,
    rx: 9.109,
    ry: 18.587,
    transform: "translate(174.65 2546.304)",
    fill: "#5d45ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_853-2",
    "data-name": "Path 853",
    d: "M549.735,208.862c3.648-21.889.037-43.7,0-43.917l-.71.12c.037.217,3.628,21.912,0,43.679Z",
    transform: "translate(-366.818 2386.452)",
    fill: "#f8e602"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_182-2",
    "data-name": "Rectangle 182",
    width: 0.72,
    height: 9.342,
    transform: "translate(175.399 2561.529) rotate(-61.858)",
    fill: "#f8e602"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_183-2",
    "data-name": "Rectangle 183",
    width: 9.342,
    height: 0.72,
    transform: "translate(184.094 2567.51) rotate(-28.158)",
    fill: "#f8e602"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_855",
    "data-name": "Path 855",
    d: "M663.565,209.25l2.3-1.836a2.433,2.433,0,0,0-2.816,1.546,3.911,3.911,0,0,0-2.91.18l4.593,1.668A3.476,3.476,0,0,0,663.565,209.25Z",
    transform: "translate(-242.272 2375.306)",
    fill: "#3f3d56"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1010.5, 2624.08)",
    filter: "url(#Rectangle_166)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_166-2",
    "data-name": "Rectangle 166",
    width: 114,
    height: 114,
    rx: 5,
    transform: "translate(16.5 35.92)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_378",
    "data-name": "Group 378",
    transform: "translate(1057.072 2689.8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_377",
    "data-name": "Group 377",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_875",
    "data-name": "Path 875",
    d: "M84,297.578a.619.619,0,0,0-.618-.618H74.728a.619.619,0,0,0-.618.618v15.757a.619.619,0,0,0,.618.618c.038,0,6.029.013,8.761.013Z",
    transform: "translate(-64.778 -259.565)",
    fill: "#ef2b75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_876",
    "data-name": "Path 876",
    d: "M152.754,251.138a.619.619,0,0,0-.618-.618h-8.657a.619.619,0,0,0-.618.618v21.6a.619.619,0,0,0,.618.618H152.7Z",
    transform: "translate(-124.87 -218.973)",
    fill: "#ffb3aa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_877",
    "data-name": "Path 877",
    d: "M221.5,193.178a.619.619,0,0,0-.618-.618h-8.657a.619.619,0,0,0-.618.618v28.9a.619.619,0,0,0,.618.618h9.082Z",
    transform: "translate(-184.963 -168.312)",
    fill: "#ffa104"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_878",
    "data-name": "Path 878",
    d: "M290.254,130.638a.619.619,0,0,0-.618-.618h-8.657a.619.619,0,0,0-.618.618v36.779a.619.619,0,0,0,.618.618h8.657Z",
    transform: "translate(-245.056 -113.647)",
    fill: "#db7026"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_191",
    "data-name": "Rectangle 191",
    width: 9.894,
    height: 45.285,
    rx: 4.91,
    transform: "translate(43.962 9.103)",
    fill: "#ee0800"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_879",
    "data-name": "Path 879",
    d: "M110.726.948a.617.617,0,0,0-1.063-.627c-3.425,5.808-9.363,12.318-15.931,17.83-6.391,5.362-13.359,9.764-19.172,11.638a.616.616,0,1,0,.377,1.172c5.971-1.924,13.089-6.412,19.588-11.865,6.668-5.595,12.706-12.221,16.2-18.148",
    transform: "translate(-64.798 -0.015)",
    fill: "#c04a2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_880",
    "data-name": "Path 880",
    d: "M320.409,6.088a.616.616,0,1,0,1.232,0l.01-5.469h0a.619.619,0,0,0-.617-.62.61.61,0,0,0-.263.058l-5.039,2.058a.617.617,0,1,0,.463,1.143l4.221-1.724Z",
    transform: "translate(-275.638)",
    fill: "#ddb38d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_881",
    "data-name": "Path 881",
    d: "M53.237,54.4a.618.618,0,1,0,0-1.237h-52V.628A.618.618,0,1,0,0,.628v53.15a.619.619,0,0,0,.618.618Z",
    transform: "translate(0 -0.009)",
    fill: "#6a3116"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_882",
    "data-name": "Path 882",
    d: "M61.5,14.137A9.069,9.069,0,1,1,55.09,11.48,9.043,9.043,0,0,1,61.5,14.137Z",
    transform: "translate(-40.225 -10.034)",
    fill: "#ffab1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_883",
    "data-name": "Path 883",
    d: "M69.879,24.413a7.725,7.725,0,1,0,2.264,5.463,7.7,7.7,0,0,0-2.264-5.463",
    transform: "translate(-49.551 -19.361)",
    fill: "#ff8b03",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_884",
    "data-name": "Path 884",
    d: "M97.305,51.315a.538.538,0,0,0-1.075,0,2.746,2.746,0,1,0,2.746-2.746,1.672,1.672,0,1,1,1.672-1.672.538.538,0,0,0,1.075,0,2.746,2.746,0,1,0-2.746,2.746,1.672,1.672,0,1,1-1.672,1.672",
    transform: "translate(-84.112 -38.59)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_885",
    "data-name": "Path 885",
    d: "M113.79,36.575a.538.538,0,0,0,1.075,0V35.408a.538.538,0,1,0-1.075,0Z",
    transform: "translate(-99.461 -30.479)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_886",
    "data-name": "Path 886",
    d: "M113.79,116.026a.538.538,0,1,0,1.075,0v-1.169a.538.538,0,0,0-1.075,0Z",
    transform: "translate(-99.461 -99.924)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_887",
    "data-name": "Path 887",
    d: "M58.953,24.4a7.732,7.732,0,0,0,2.03,12.387,7.886,7.886,0,0,1-.869-.749,7.729,7.729,0,0,1,8.9-12.389,7.726,7.726,0,0,0-10.058.751",
    transform: "translate(-49.551 -19.352)",
    fill: "#ff5958",
    fillRule: "evenodd"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalesTriggers);
export default __webpack_public_path__ + "static/media/sales-triggers.79d7780997fe94fdec9fef4418aae12f.svg";
export { ForwardRef as ReactComponent };